import { Table } from "react-bootstrap";

// rows: [{ label: string, links: { [columnKey]: { path, external } | null } }]
// columns: [{ key, header }]
function DocTable({ columns, rows }) {
    return (
        <Table responsive bordered className="doc-archive-table">
            <thead>
                <tr>
                    <th></th>
                    {columns.map((col) => (
                        <th key={col.key}>{col.header}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, i) => (
                    <tr key={`doc-row-${i}`}>
                        <td className="doc-archive-label">{row.label}</td>
                        {columns.map((col) => {
                            const link = row.links[col.key];
                            return (
                                <td key={col.key} className="doc-archive-cell">
                                    {link ? (
                                        <a
                                            href={link.path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="doc-archive-link"
                                        >
                                            {link.text || col.header}
                                        </a>
                                    ) : (
                                        <span className="doc-archive-missing">—</span>
                                    )}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default DocTable;
